import { Navigate, useParams } from "react-router-dom";

import { getLeadSource } from "routes/leads/leadSourceRegistry";

// Reads the :service URL segment and dispatches to that provider's own screen.
// This is the routing seam: unknown services redirect rather than crash, and
// each provider keeps its own components behind its registry entry.

export const LeadSourceManage = () => {
  const { service } = useParams();
  const source = getLeadSource(service);
  if (!source) {
    return <Navigate to="/" replace />;
  }
  const { ManageComponent } = source;
  return <ManageComponent />;
};

export const LeadSourceForm = ({ mode }) => {
  const { service } = useParams();
  const source = getLeadSource(service);
  if (!source) {
    return <Navigate to="/" replace />;
  }
  const { FormComponent } = source;
  return <FormComponent mode={mode} />;
};

export const LeadSourceLeads = () => {
  const { service } = useParams();
  const source = getLeadSource(service);
  if (!source) {
    return <Navigate to="/" replace />;
  }
  const { LeadsComponent } = source;
  return <LeadsComponent />;
};

export const LeadSourceLeadDetail = () => {
  const { service } = useParams();
  const source = getLeadSource(service);
  if (!source) {
    return <Navigate to="/" replace />;
  }
  const { LeadDetailComponent } = source;
  return <LeadDetailComponent />;
};
